import templateUrl from "./edit-address.html"

export const EditAddressComponent = {
    templateUrl,
    controller: EditAddressController,
    controllerAs: "vm",
    bindings: {
        address: "<",
        required: "<?",
        stateProvinces: "<"
    }
};

export function EditAddressController($q, localeService) {
    'ngInject'
    const vm = this;
    vm.address;
    vm.addressForm;
    vm.countries;
    vm.filteredStateProvinces;
    vm.onChangeCountry = onChangeCountry;
    vm.onChangeStateProvince = onChangeStateProvince;
    vm.required;
    vm.stateProvinces;
    vm.stateProvinceLabel = "State/Province";
    vm.postalCodeLabel = "Postal/Zip Code";

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
        vm.address = vm.address || {};
        vm.stateProvinces = vm.stateProvinces || [];
        vm.countries = vm.countries || [];

        loadLocales().then(function () {
            loadLocaleTranslations(vm.locales, vm.address.Country);
        });
    }

    function onChanges(changesObj) {
        if (changesObj.stateProvinces && vm.stateProvinces) {
            // State province references in the address won't be the same based on object reference, so
            // need to recompare based on ID.
            vm.countries = vm.stateProvinces.reduce(function (countries, stateProvince) {
                const isNew = countries.filter(function (country) {
                    return Number(country.CountryID) === Number(stateProvince.CountryID);
                }).length === 0;
                if (isNew && stateProvince.Country) {
                    countries.push(stateProvince.Country);
                }
                return countries;
            }, []).sort(function (a, b) {
                return a.CountryName < b.CountryName ? -1 : 1;
            });
        }

        if ((changesObj.address || changesObj.stateProvinces) && vm.address && vm.stateProvinces) {
            // Map the selected state/country data from the original lists back into the address.
            vm.address.StateProvince = vm.stateProvinces.filter(function (stateProvince) {
                return Number(stateProvince.StateProvinceID) === Number(vm.address.StateProvinceID);
            })[0];
            vm.address.StateProvinceID = vm.address.StateProvince
                ? Number(vm.address.StateProvince.StateProvinceID) : null;

            vm.address.Country = vm.countries.filter(function (country) {
                return vm.address.StateProvince && Number(country.CountryID)
                    === Number(vm.address.StateProvince.CountryID);
            })[0];
            vm.address.CountryID = vm.address.Country ? Number(vm.address.Country.CountryID) : null;
            updateFilteredStateProvinces(vm.address.Country);

            loadLocales()
                .then(function () {
                    loadLocaleTranslations(vm.locales, vm.address.Country);
                });
        }
    }

    function loadLocales() {
        return vm.locales ? $q.resolve(vm.locales) : localeService.retrieveLocales()
            .then(locales => vm.locales = locales);
    }

    function onChangeCountry() {
        if (vm.address.Country) {
            vm.address.CountryID = Number(vm.address.Country.CountryID);
        } else {
            vm.address.CountryID = null;
        }
        updateFilteredStateProvinces(vm.address.Country);
        loadLocaleTranslations(vm.locales, vm.address.Country);
    }

    function onChangeStateProvince() {
        if (vm.address.StateProvince) {
            // Auto-set the country to the selected state/province country.
            vm.address.Country = vm.countries.filter(function (country) {
                return Number(country.CountryID) === Number(vm.address.StateProvince.CountryID);
            })[0];
            vm.address.StateProvinceID = Number(vm.address.StateProvince.StateProvinceID);
            onChangeCountry();
        } else {
            vm.address.StateProvinceID = null;
        }
    }

    function loadLocaleTranslations(locales, country) {
        const getCurrentLocale = country ? $q.when(locales.filter(function (locale) {
            return locale.countryID === country.CountryID;
        })[0]) : localeService.retrieveCurrentLocale();

        // TODO: cache results.
        getCurrentLocale
            .then(function (currentLocale) {
                return localeService.retrieveLocaleTranslations(currentLocale.localeID);
            })
            .then(function (translations) {
                // Change the label text to that of the selected country.
                vm.stateProvinceLabel = translations.StateProvince;
                vm.postalCodeLabel = translations.PostalCode;
            });

    }

    function updateFilteredStateProvinces(country) {
        vm.filteredStateProvinces = vm.stateProvinces.filter(function (stateProvince) {
            // Only show states belonging to the selected country if a country is selected.
            return !country || stateProvince.CountryID === country.CountryID;
        });
    }
}
